import React from 'react';
import {icons, OntarioRow} from '../../../theme';
import {
    HorizontalRule,
    StepIndicatorBtnContainer,
    StepIndicatorContainer,
  StepIndicatorColumn,
    StepIndicatorSpan,
    StyledBackLink,
} from './styles';
import Button from './button';
import {FormSections, ProgramContainer} from '../../../entities/formTemplateDataType';
import {cleanup} from '../../../security/PublicSecure';
import {BackHome} from '../../../entities/Constants';
import {getRootComponent, isBxpForm} from '../../../utilities/ElementUtils';
import SectionUtils from '../../../utilities/SectionUtils';
import CustomPopup from '../PopupComponent';
import { replaceTitlePlaceholders } from '../../../commonComponent/TileSelectionComponent';
import { getEnvVar, SCRIPT_ENV } from '../../../config/RuntimeConfig';

const BACK_BUTTON_POPUP_DEFAULT = {
  en: {
    title: 'Are you sure you want to exit?',
    message: 'If you leave this page, your progress will not be saved.',
    stay: 'Stay on this page',
    leave: 'Exit without saving',
  },
  fr: {
    title: 'Quitter cette page?',
    message: 'Voulez-vous revenir à la page précédente?',
    stay: 'Rester sur cette page',
    leave: 'Quitter sans enregistrer',
  },
};


interface Props {
  withbackbtn: boolean;
  sectionSequence: number;
  // totalSteps?: Set<number>;
  section?: FormSections;
  programContainer?: ProgramContainer;
  title: string;
  isEng: boolean;
  isTechicalErrorPage?: boolean;
  topNavigation?: boolean;
  leftButtons?: any;
  rightButtons?: any;
  showReview?: boolean;
  backToUrl?: string;
  customOnclick?: () => void;
  callback?: (currentStep: number) => void;
}

interface State {
  showBackPopup: boolean;
}

export default class StepIndicator extends React.Component<Props, State> {

  constructor(props: Props) {
    super(props);

    this.state = {
      showBackPopup: false,
    };
  }

  componentDidUpdate(prevProps: Readonly<Props>) {
    const prevSequence = prevProps.section ? prevProps.section.Sequence : prevProps.sectionSequence;
    const currentSequence = this.props.section ? this.props.section.Sequence : this.props.sectionSequence;

    if (this.state.showBackPopup && prevSequence !== currentSequence) {
      this.setState({ showBackPopup: false });
    }
  }

  backToHome = (backButtonLabel: string) => {
    const lang = this.props.isEng ? "en" : "fr";
    const root = this.props.programContainer ? this.props.programContainer : getRootComponent(this.props.section);
    const isBpsApp = !!root?.BpsConfig?.domain;
    if (backButtonLabel === BackHome.Ontario[lang].label) {
      cleanup(root.CategoryId.toLowerCase(), root);
      window.location.replace(BackHome.Ontario[lang].url);
    } else if (backButtonLabel === BackHome.Home[lang].label) {
      cleanup(root.CategoryId.toLowerCase(), root);
      const homeUrl = isBpsApp ? (getEnvVar('BPS_REDIRECT_URI') || window.location.origin) : BackHome.Home[lang].url;
      window.location.replace(homeUrl);
    }
  }

  render() {

    let programContainer = this.props.programContainer;

    if (this.props.section) {
      programContainer = this.props.section.parent
    }

    let sections = programContainer.ListOfFormSections;
    const isBXP =isBxpForm(programContainer.CategoryId)
    let totalSteps = sections
      .filter(p =>
        Boolean(p.Visible) &&
        !Boolean(p.NotStep) &&
        !Boolean(p.IsTechErrorPage) &&
        !Boolean(p.IsInfoPage) &&
        !Boolean(p.IsConfirmationPage)
      )
      .map(p => p.Sequence)             // numeric-only (no partial parse like "12a" -> 12)
      .filter(n => Number.isFinite(n))      // drop NaN/invalid
      .sort((a, b) => a - b);     
    if(isBXP){
        // Always add the last section's Sequence since it may be invisible but still counted in steps
      if (sections.length > 0) {
        const lastSection = sections[sections.length - 1];
        if (
        Number.isFinite(lastSection.Sequence) &&
        !totalSteps.includes(lastSection.Sequence)
        ) {
          totalSteps.push(lastSection.Sequence);
        }
      } 
    }
    const currentSequence = this.props.section ? this.props.section.Sequence : this.props.sectionSequence;
    let currentStepIndex = totalSteps.indexOf(currentSequence);
    
    if (isBXP && typeof window !== 'undefined') {
      (window as any).currentBXPStepIndex = totalSteps.indexOf(this.props.section ? this.props.section.Sequence : this.props.sectionSequence);
    }
    let totalStepNumber = totalSteps.length;

    if (SectionUtils.findNotCountedStep(programContainer) != -1) {
      totalStepNumber--;
    }

    if (currentSequence> SectionUtils.findNotCountedStep(programContainer)&& SectionUtils.findNotCountedStep(programContainer)>-1) {
      currentStepIndex--;
    }

    let profileInfo = programContainer?.Profile;
    let section = programContainer.ListOfFormSections[currentSequence - 1];

    // When on a confirmation page (sectionSequence=-1), find the actual confirmation section
    // so we can read its BackButton configs
    if (!section && currentSequence === -1) {
      section = programContainer.ListOfFormSections.find(s => s.IsConfirmationPage);
    }

    // When on a tech error page, find the actual tech error section
    // so we can read its BackButton configs
    if (!section && this.props.isTechicalErrorPage) {
      section = programContainer.ListOfFormSections.find(s => s.IsTechErrorPage);
    }

    const getLocalizedText = (englishValue?: string, frenchValue?: string) =>
      this.props.isEng ? englishValue : frenchValue;

    const hasLocalizedText = (englishValue?: string, frenchValue?: string) =>
      Boolean(getLocalizedText(englishValue, frenchValue));

    const getLocalizedUrl = (englishValue?: string, frenchValue?: string) =>
      this.props.isEng ? englishValue : (frenchValue ?? englishValue);

    const normalizeBackConfigUrl = (url?: string) => {
      if (!url) return url;

      const trimmedUrl = url.trim();
      if (!trimmedUrl) return trimmedUrl;

      if (trimmedUrl.startsWith('https://')) {
        return trimmedUrl;
      }

      const appDomain = typeof window !== 'undefined' ? window.location.origin : '';
      if (!appDomain) {
        return trimmedUrl;
      }
      if (trimmedUrl.startsWith('/')) {
        return `${appDomain}${trimmedUrl}`;
      }

      return `${appDomain}/${trimmedUrl}`;
    };

    const hasLocalizedUrl = (englishValue?: string, frenchValue?: string) =>
      Boolean(getLocalizedUrl(englishValue, frenchValue));



    if (!this.props.withbackbtn) return false;

      let backButtonLabel, backUrl;
      const lang = this.props.isEng ? "en" : "fr";
      const userProfile = sessionStorage.getItem("userProfile");
      const isSignedIn = Boolean(profileInfo?.userId || profileInfo?.email || userProfile);

      const signedInLabel = getLocalizedText(section?.BackButtonSignedInLabel, section?.BackButtonSignedInLabelFRA);
      const signedInUrl = normalizeBackConfigUrl(getLocalizedUrl(section?.BackButtonSignInURL, section?.BackButtonSignInURLFRA));
      const hasSignedInLabel = hasLocalizedText(section?.BackButtonSignedInLabel, section?.BackButtonSignedInLabelFRA);
      const hasSignedInUrl = hasLocalizedUrl(section?.BackButtonSignInURL, section?.BackButtonSignInURLFRA);

      const publicLabel = getLocalizedText(section?.BackButtonLabel, section?.BackButtonLabelFRA);
      const publicUrl = normalizeBackConfigUrl(getLocalizedUrl(section?.BackButtonURL, section?.BackButtonURLFRA));
      const hasPublicLabel = hasLocalizedText(section?.BackButtonLabel, section?.BackButtonLabelFRA);
      const hasPublicUrl = hasLocalizedUrl(section?.BackButtonURL, section?.BackButtonURLFRA);

      const configuredBackUrl = isSignedIn ? signedInUrl : publicUrl;
      const hasConfiguredBackUrl = isSignedIn ? hasSignedInUrl : hasPublicUrl;

      // Detect BPS-protected apps to avoid routing to Public Secure sign-in
      const isBpsApp = !!programContainer?.BpsConfig?.domain;
      const bpsHomeUrl = isBpsApp ? (getEnvVar('BPS_REDIRECT_URI') || window.location.origin) : '';

      if (isSignedIn) {  // CXP user - authenticated
          if (hasSignedInLabel && hasSignedInUrl) {
              backButtonLabel = signedInLabel;
              backUrl = signedInUrl;
          } else {
              backButtonLabel = currentSequence > 1
                  ? (hasPublicLabel ? publicLabel : BackHome.Back[lang].label)
                  : BackHome.Home[lang].label;
              backUrl = currentSequence > 1 ? "" : (isBpsApp ? bpsHomeUrl : BackHome.Home[lang].url);
          }
      } else {  // Public user - unauthenticated
          if (hasPublicLabel && hasPublicUrl) {
              backButtonLabel = publicLabel;
              backUrl = publicUrl;
          } else {
              backButtonLabel = currentSequence > 1
                  ? (hasPublicLabel ? publicLabel : BackHome.Back[lang].label)
                  : BackHome.Ontario[lang].label;
              backUrl = this.props.backToUrl;
          }
      }

      const isCxpUser = isSignedIn;
      if (section?.IsConfirmationPage) {
        // Only apply hardcoded defaults when no section-level back button config is set
        if (isCxpUser) {
          if (!(hasSignedInLabel && hasSignedInUrl) && !(hasPublicLabel && hasPublicUrl)) {
            backButtonLabel = BackHome.Home[lang].label;
            backUrl = isBpsApp ? bpsHomeUrl : BackHome.Home[lang].url;
          }
        } else {
          if (!(hasPublicLabel && hasPublicUrl)) {
            backButtonLabel = BackHome.Ontario[lang].label;
            backUrl = BackHome.Ontario[lang].url;
          }
        }
      }

    // Only update section if values changed to avoid render loops
    if (section) {
      if (this.props.isEng) {
        if (section.BackButtonLabel !== backButtonLabel || section.BackButtonURL !== backUrl) {
          section.BackButtonLabel = backButtonLabel;
          section.BackButtonURL = backUrl;
        }
      } else {
        if (section.BackButtonLabelFRA !== backButtonLabel || section.BackButtonURLFRA !== backUrl) {
          section.BackButtonLabelFRA = backButtonLabel;
          section.BackButtonURLFRA = backUrl;
        }
      }
    }

    const hasPreviousStep = currentStepIndex > 0 || (Number.isFinite(currentSequence) && currentSequence > 1);
    const wantsPopup = section?.BackButtonShowPopup;
    const specialCase = isSignedIn
      ? (
        section?.Sequence === 1 ||
        section?.IsFrontPage ||
        currentSequence === -1 ||
        this.props.isTechicalErrorPage ||
        this.props.section?.IsConfirmationPage ||
        hasSignedInUrl
      )
      : (
        section?.Sequence === 1 ||
        section?.IsFrontPage ||
        currentSequence === -1 ||
        this.props.isTechicalErrorPage ||
        this.props.section?.IsConfirmationPage
      );
    const shouldShowBackPopup = Boolean(wantsPopup && hasPreviousStep && !specialCase && !section.SectionReadonly && SectionUtils.isSectionDirty(section));
    const popupCopy = BACK_BUTTON_POPUP_DEFAULT[lang];
    const popupTitle = this.props.isEng
      ? (section?.BackButtonPopupTitle || popupCopy.title)
      : (section?.BackButtonPopupTitleFRA || popupCopy.title);
    const popupMessage = this.props.isEng
      ? (section?.BackButtonPopupMessage || popupCopy.message)
      : (section?.BackButtonPopupMessageFRA || popupCopy.message);
    const stayLabel = this.props.isEng
      ? (section?.BackButtonPopupStayLabel || popupCopy.stay)
      : (section?.BackButtonPopupStayLabelFRA || popupCopy.stay);
    const leaveLabel = this.props.isEng
      ? (section?.BackButtonPopupLeaveLabel || popupCopy.leave)
      : (section?.BackButtonPopupLeaveLabelFRA || popupCopy.leave);
    const showBackPopup = shouldShowBackPopup && this.state.showBackPopup;
    const hasBackButtonStepperScript =
      typeof section?.BackButtonStepperScript === "string" &&
      section.BackButtonStepperScript.trim().length > 0;

    const executeBackButtonStepperScript = () => {
      if (!hasBackButtonStepperScript) return false;

      try {
        const customJSFunc = eval(`(${section.BackButtonStepperScript})`);
        customJSFunc((destination) => {
          if (!this.props.callback) return;
          if (typeof destination === "string") {
            const root = programContainer ?? getRootComponent(section);
            const foundSection = root?.ListOfFormSections?.find(
              (item) => item.ENUTitle == destination
            );
            const indexNum = root?.ListOfFormSections?.indexOf(foundSection);
            this.props.callback(indexNum);
          } else {
            this.props.callback(destination);
          }
        }, section, programContainer, SCRIPT_ENV);
      } catch (ex) {
        console.log(ex);
      }

      return true;
    };

    const handleBackNavigation = () => {
      if (this.props.section?.IsConfirmationPage && this.props.section?.StepperScript) {
        const customJSFunc = eval(`(${this.props.section.StepperScript})`);
        customJSFunc((index) => {
          this.props.callback(index);
        });
        return;
      }

      if (hasConfiguredBackUrl && configuredBackUrl) {
        if (isSignedIn) {
          cleanup(programContainer.CategoryId.toLowerCase(), programContainer);
        }
        window.location.replace(configuredBackUrl);
        return;
      }

      if (isSignedIn) {
        if ((section?.Sequence == 1 || section?.IsFrontPage || currentSequence == -1 || this.props.isTechicalErrorPage || this.props.section.IsConfirmationPage)) {
          const path = this.props.isEng ? "/dashboard" : "/fr/dashboard";
          const url = backUrl || getEnvVar('PUBLIC_CXP_WEB_BASE_PATH') + "/auth/signin?redirectUri=" + path;
          cleanup(programContainer.CategoryId.toLowerCase(), programContainer);
          window.location.replace(url);
        } else {
          currentStepIndex = totalSteps.indexOf(currentSequence);
          const previousStepIndex = currentStepIndex - 1;
          let previousIndex = totalSteps[previousStepIndex] - 1;
          const immediatePrevSection = programContainer.ListOfFormSections[currentSequence - 2];
          if (immediatePrevSection?.CustomizedReviewPage) {
            previousIndex = immediatePrevSection.Sequence - 1;
          }
          if (isNaN(previousIndex)) {
            previousIndex = undefined;
          }
          this.props.callback(previousIndex)
        }
      } else {
        if ((section.Sequence==1 || section?.IsFrontPage || currentSequence == -1 || this.props.isTechicalErrorPage || this.props.section.IsConfirmationPage)) {
          window.location.replace(section?.BackButtonURL || section?.BackButtonURLFRA || (this.props.isEng ? (programContainer?.OriginURL ? programContainer.OriginURL : "https://www.ontario.ca/page/serviceontario") : (programContainer?.OriginURLFRA ? programContainer.OriginURLFRA : "https://www.ontario.ca/fr/page/serviceontario")));
        } else {
          currentStepIndex = totalSteps.indexOf(currentSequence);
          const previousStepIndex = currentStepIndex - 1;
          let previousIndex = totalSteps[previousStepIndex] - 1;
          const immediatePrevSection = programContainer.ListOfFormSections[currentSequence - 2];
          if (immediatePrevSection?.CustomizedReviewPage) {
            previousIndex = immediatePrevSection.Sequence - 1;
          }
          if (isNaN(previousIndex)) {
            previousIndex = undefined;
          }

          if (isBXP && typeof window !== 'undefined') {
              (window as any).currentBXPStepIndex = previousStepIndex;
          }

          this.props.callback(previousIndex)
        }
      }
    };

    const triggerBackNavigation = (event?: React.MouseEvent<HTMLElement>) => {
      if (executeBackButtonStepperScript()) {
        event?.preventDefault();
        event?.stopPropagation();
        return;
      }
      if (shouldShowBackPopup) {
        event?.preventDefault();
        event?.stopPropagation();
        this.setState({ showBackPopup: true });
        return;
      }

      handleBackNavigation();
    };

    const confirmBackNavigation = () => {
      this.setState({ showBackPopup: false }, () => {
        handleBackNavigation();
      });
    };

    const dismissBackPopup = () => {
      this.setState({ showBackPopup: false });
    };

    return (

      <StepIndicatorContainer>
        {shouldShowBackPopup && (
          <CustomPopup
            key="back-button-popup"
            isVisible={showBackPopup}
            title={popupTitle}
            closable={true}
            handleModalClose={dismissBackPopup}
            customClass="custom-popup back-button-popup"
          >
            <div className="popup-content">
              <p>{popupMessage}</p>
              <div className="popup-buttons">
                <button
                  className="ontario-button ontario-button--primary"
                  onClick={(e) => {
                    e.preventDefault();
                     dismissBackPopup();
                  }}
                >
                 {stayLabel}
                </button>
                <button
                  className="ontario-button ontario-button--secondary"
                  onClick={(e) => {
                    e.preventDefault();
                    confirmBackNavigation();
                  }}
                > 
                  {leaveLabel}
                </button>
              </div>
            </div>
          </CustomPopup>
        )}
        <OntarioRow>
          {this.props.withbackbtn && (
            <StepIndicatorBtnContainer withbackbtn={this.props.withbackbtn}>
              <StepIndicatorColumn>
                {!this.props.showReview && (
                  (backButtonLabel === BackHome.Ontario[lang].label && !hasBackButtonStepperScript) ? (
                    <StyledBackLink
                      href={backUrl || BackHome.Ontario[lang].url}
                      aria-label={this.props.title}
                      onClick={(e) => {
                        cleanup(programContainer.CategoryId.toLowerCase(), programContainer);
                      }}
                    >
                      {icons.chevronLeftSVG}
                      {backButtonLabel}
                    </StyledBackLink>
                  ) : (
                    <Button
                      aria-label={this.props.title}
                      appearance="stepIndicatorBtn"
                      backIcon={this.props.withbackbtn}
                      onClick={triggerBackNavigation}
                    >
                      {backButtonLabel}
                    </Button>
                  )
                )}

                {this.props.topNavigation ? this.props.leftButtons : ''}
              </StepIndicatorColumn>

              <StepIndicatorColumn align="right">
                <div className="step-indicator-right-actions">
                  {this.props.topNavigation ? this.props.rightButtons?.props?.children && React.Children.toArray(this.props.rightButtons.props.children) : ''}
                </div>
                {currentStepIndex >= 0 && totalStepNumber > 0 && (
                  <div
                    className="step-indicator-step"
                    style={{ display: section?.NotStep || section?.NoStepIndicator || currentSequence== -1 || this.props.isTechicalErrorPage == true || section?.NotCountedInSteps ? "none" : "block" }}
                  >
                    <div style={{ display: this.props.isEng ? "block" : "none" }}>
                      <StepIndicatorSpan>
                        {"Step " + (currentStepIndex + 1).toString() + (section?.NoTotalPages || section?.IsTechErrorPage ? '' : " of " + totalStepNumber)}
                      </StepIndicatorSpan>
                    </div>

                    <div style={{ display: this.props.isEng ? "none" : "block" }}>
                      <StepIndicatorSpan>
                        {"Étape " + (currentStepIndex + 1).toString() + (section?.NoTotalPages || section?.IsTechErrorPage ? '' : " de " + totalStepNumber)}
                      </StepIndicatorSpan>
                    </div>
                  </div>
                )}
              </StepIndicatorColumn>
            </StepIndicatorBtnContainer>
          )}
          {!this.props.withbackbtn && (
            <StepIndicatorBtnContainer withbackbtn={this.props.withbackbtn}>
              <StepIndicatorSpan>

              </StepIndicatorSpan>
            </StepIndicatorBtnContainer>
          )}
          {section?.TitleInStepIndicator && <>
            <div style={{ display: section?.IsTerminationPage || section.CustomizedReviewPage ? "none" : "block" }}
              className="ontario-h1 ontario-margin-bottom-0-!"
            >
              {replaceTitlePlaceholders(this.props.isEng ? section?.ENUTitle : section?.FRATitle)}
            </div>

            <div style={{ display: section?.IsTerminationPage || section.CustomizedReviewPage ? "none" : "block" }}
              className={!section?.IsTerminationPage && section?.ENUDescription ? "ontario-margin-top-24-! ontario-margin-bottom-40-!" : ""}>
              {this.props.isEng ? section?.ENUDescription : section?.FRADescription}
            </div>
          </>}
          <HorizontalRule />
        </OntarioRow>
      </StepIndicatorContainer>
    )
  }

  checkIfFormIsDirty = (): boolean => {
    let programContainer = this.props.programContainer;
    if (this.props.section) {
      programContainer = this.props.section.parent
    }
    return SectionUtils.isFormDirty(programContainer);
  }
}
